import React from "react";
import { ArrowDown, ArrowUp, ArrowUpDown, Lock } from "lucide-react";
import { formatCell, isNumeric } from "./format";
import { cn } from "../../lib/utils";

function Head({ col, sort, dir, masked, onSort }) {
  const locked = col.pii && masked;
  const active = sort === col.key;
  const Icon = active ? (dir === "asc" ? ArrowUp : ArrowDown) : ArrowUpDown;
  return (
    <th className={cn("px-3 py-2 font-semibold whitespace-nowrap", isNumeric(col) ? "text-right" : "text-left")}>
      <button type="button" data-testid={`dt-sort-${col.key}`} disabled={locked} title={locked ? "Masked — cannot be sorted" : col.description || col.key}
              onClick={() => onSort(col.key)}
              className={cn("inline-flex items-center gap-1 font-mono-tabular normal-case tracking-normal text-[10.5px] transition-colors",
                active ? "text-primary" : "text-muted hover:text-fg", locked && "cursor-not-allowed opacity-70 hover:text-muted")}>
        {col.key}
        {locked ? <Lock size={10} /> : <Icon size={10} className={active ? "" : "opacity-40"} />}
      </button>
    </th>
  );
}

// The list view: every visible field, sortable headers, click a row for its full record.
export default function DataGrid({ columns, rows, sort, dir, masked, onSort, onOpen, openId, loading }) {
  return (
    <div className={cn("overflow-x-auto border-y border-border transition-opacity", loading && "opacity-60")} data-testid="dt-grid">
      <table className="w-full text-[11.5px]">
        <thead className="bg-surface-2/50 sticky top-0">
          <tr className="border-b border-border">
            {columns.map(c => <Head key={c.key} col={c} sort={sort} dir={dir} masked={masked} onSort={onSort} />)}
          </tr>
        </thead>
        <tbody className="font-mono-tabular">
          {rows.map(r => (
            <tr key={r._rid} data-testid={`dt-row-${r._rid}`} onClick={() => onOpen(r)}
                className={cn("border-b border-border/60 cursor-pointer transition-colors",
                  openId === r._rid ? "bg-primary/10" : "hover:bg-surface-2/50")}>
              {columns.map(c => (
                <td key={c.key} className={cn("px-3 py-1.5 whitespace-nowrap max-w-[280px] truncate",
                  isNumeric(c) && "text-right", c.pii && masked && "text-muted")}>{formatCell(c, r[c.key])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
